/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Ai_Tools_Trust_Nosub_TitleInputs */

const en_directory_ai_tools_trust_nosub_title = /** @type {(inputs: Directory_Ai_Tools_Trust_Nosub_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No subscription`)
};

const zh_directory_ai_tools_trust_nosub_title = /** @type {(inputs: Directory_Ai_Tools_Trust_Nosub_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`无需订阅`)
};

/**
* | output |
* | --- |
* | "No subscription" |
*
* @param {Directory_Ai_Tools_Trust_Nosub_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_ai_tools_trust_nosub_title = /** @type {((inputs?: Directory_Ai_Tools_Trust_Nosub_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Ai_Tools_Trust_Nosub_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_ai_tools_trust_nosub_title(inputs)
	return zh_directory_ai_tools_trust_nosub_title(inputs)
});
export { directory_ai_tools_trust_nosub_title as "directory.ai_tools.trust.nosub_title" }